const orderFr = {
    "total": "Total",
    "order_successfully_placed": "Commande passée",
    "empty_cart": "Votre panier est actuellement vide.",
    "place_order": "Passer la commande",
    "i_order": "Passer la commande",
    "order_confirmation": "Confirmation de commande",
    "order_confirmation_msg_raw": "En passant votre commande, vous acceptez nos conditions d'utilisation et notre politique de confidentialité, que vous pouvez trouver dans le <a href=\":link\" class=\"generated-link\" target=\"_blank\">lien ci-dessous</a>.",
    "status_PLACED": "Mis",
    "status_ACCEPTED": "Accepté",
    "status_SERVED": "Servi",
    "status_PAID": "Payé",
    "empty_pending_orders": "Vous n'avez aucune commande en attente pour le moment.",
    "overview": "Aperçu de la commande",
    "note": "Note",
    "items": "Articles",
    "review_order": "Aperçu"
};

export default orderFr;
